import DateTimeFormatOptions = Intl.DateTimeFormatOptions;
import {UniFocusEnvironment} from '../../environment/Environment';

const UTC = 'UTC';
const TWO_DIGIT = '2-digit';
const NUMERIC = 'numeric';
const NARROW = 'narrow';
const SHORT = 'short';
const LONG = 'long';

const baseFormatOptions = (environment: UniFocusEnvironment): Partial<DateTimeFormatOptions> => ({
   timeZone: UTC,
   hour12: !environment.timeMode24Hour
});

export const dateFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   year: TWO_DIGIT,
   month: NUMERIC,
   day: NUMERIC
});

export const dateYearLongFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   year: NUMERIC,
   month: NUMERIC,
   day: NUMERIC
});

export const dateMediumFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   year: NUMERIC,
   month: SHORT,
   day: NUMERIC
});

export const dateLongFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   year: NUMERIC,
   month: LONG,
   day: NUMERIC
});

export const dateFullFormatOptions = (environment: UniFocusEnvironment,
                                      shortWeekday: boolean,
                                      shortMonth: boolean): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   year: NUMERIC,
   month: shortMonth ? SHORT : LONG,
   day: NUMERIC,
   weekday: shortWeekday ? SHORT : LONG
});

export const dateCellFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   year: NUMERIC,
   month: TWO_DIGIT,
   day: TWO_DIGIT
});

export const dateWithDowFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...dateFormatOptions(environment),
   weekday: SHORT
});

export const dateTimeFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   year: TWO_DIGIT,
   month: NUMERIC,
   day: NUMERIC,
   hour: environment.timeMode24Hour ? TWO_DIGIT : NUMERIC,
   minute: TWO_DIGIT,
   second: TWO_DIGIT
});

export const timeFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   hour: environment.timeMode24Hour ? TWO_DIGIT : NUMERIC,
   minute: TWO_DIGIT
});

export const timeFormatWithSecondsOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   hour: environment.timeMode24Hour ? TWO_DIGIT : NUMERIC,
   minute: TWO_DIGIT,
   second: TWO_DIGIT
});

export const hourFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   hour: environment.timeMode24Hour ? TWO_DIGIT : NUMERIC,
});

export const weekdayNarrowFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   weekday: NARROW
});

export const weekdayShortFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   weekday: SHORT
});

export const weekdayLongFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   weekday: LONG
});

export const monthDayFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   month: NUMERIC,
   day: NUMERIC
});

export const monthYearFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   year: TWO_DIGIT,
   month: NUMERIC
});

export const monthShortFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   month: SHORT
});

export const monthLongFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   month: LONG
});

export const yearLongFormatOptions = (environment: UniFocusEnvironment): DateTimeFormatOptions => ({
   ...baseFormatOptions(environment),
   year: NUMERIC
});
